import { useEffect, useCallback } from 'react'

import {
  GTM_ENV_VAR as GEV,
  PAGE_TYPES,
} from '../../../../lib/eventTrackerFunction'

const useTrackerHook = ({
  state: {
    errors,
    isLegalAge,
    isRenewingMembership,
    isSubscribingPromotions,
    packageOption,
  },
  track,
  userId,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const trackMembership = useCallback(options => {
    return track({
      [GEV.EVENT_CAT]: 'Ecommerce-Conversion',
      [GEV.JWC_MEMBERSHIP]: packageOption,
      [GEV.AGE_ABOVE_18]: isLegalAge,
      [GEV.JWC_CONSENTPROMOTION]: isSubscribingPromotions,
      [GEV.JWC_ID]: userId,
      [GEV.JWC_REFERRER]: document.referrer,
      ...options,
    })
  })

  useEffect(() => {
    if (errors.length > 0) {
      return trackMembership({
        //track renew membership errors
        [GEV.PAGE_TYPE]: isRenewingMembership
          ? PAGE_TYPES.JWC_HOMEPAGE
          : PAGE_TYPES.JWC_REGISTRATION,
        [GEV.SCREEN_NAME]: isRenewingMembership
          ? `${PAGE_TYPES.JWC_HOMEPAGE}_Renewal`
          : `${PAGE_TYPES.JWC_REGISTRATION}_Error`,
        [GEV.EVENT_ACTION]: isRenewingMembership
          ? 'Renewal_Jwcmembership_Error'
          : 'Register_Jwcmembership_Error',
        [GEV.EVENT_LABEL]: isRenewingMembership
          ? 'Label=Renewal-ErrorMsg'
          : 'Label=Register-ErrorMsg',
        [GEV.ASSET_TYPE]: 'JWC',
      })
    }

    return trackMembership({
      // track renew membership and consent
      [GEV.PAGE_TYPE]: isRenewingMembership
        ? PAGE_TYPES.JWC_HOMEPAGE
        : PAGE_TYPES.JWC_REGISTRATION,
      [GEV.SCREEN_NAME]: isRenewingMembership
        ? `${PAGE_TYPES.JWC_HOMEPAGE}_Renewal`
        : PAGE_TYPES.JWC_REGISTRATION,
      [GEV.EVENT_ACTION]: isRenewingMembership
        ? 'Click_Renewal_Jwcmembership'
        : 'Click_Register_Jwcmembership',
      [GEV.EVENT_LABEL]: isRenewingMembership
        ? 'Label=Renewal-Renewal'
        : 'Loc=Register-Register',
      [GEV.ASSET_TYPE]: 'JWC',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors])

  useEffect(() => {
    trackMembership({
      // track renewal view
      [GEV.PAGE_TYPE]: isRenewingMembership
        ? PAGE_TYPES.JWC_HOMEPAGE
        : PAGE_TYPES.JWC_REGISTRATION,
      [GEV.SCREEN_NAME]: isRenewingMembership
        ? `${PAGE_TYPES.JWC_HOMEPAGE}_Renewal`
        : PAGE_TYPES.JWC_REGISTRATION,
      [GEV.EVENT_ACTION]: isRenewingMembership
        ? 'Renewal_Jwcmembership_Page'
        : 'Register_Page',
      [GEV.EVENT_LABEL]: isRenewingMembership
        ? 'Label=Renewal'
        : 'Loc=Register',
      [GEV.ASSET_TYPE]: 'JWC',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { trackMembership }
}

export default useTrackerHook
